export default __webpack_public_path__ + "static/media/sync.782dd912.svg";